<p-select
  appendTo="body"
  class="app-select"
  [options]="options()"
  [optionLabel]="optionLabel()"
  [optionValue]="optionValue()"
  [placeholder]="placeholder()"
  [filterPlaceholder]="filterPlaceholder()"
  [filter]="filter()"
  [filterBy]="optionLabel()"
  [showClear]="showClear()"
  [loading]="loading()"
  [(ngModel)]="selectedValue"
  (onFilter)="onFilter($event)"
  (onChange)="onOptionSelect($event)"
>
  <ng-template #dropdownicon>
    <svg icon="arrows" />
  </ng-template>

  @if (footerTemplate(); as footerTemplate) {
    <ng-template #footer>
      <div class="app-select__footer">
        <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
      </div>
    </ng-template>
  }
</p-select>
